import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

//components
// import Dropdown from './dropdown'
// import { SignUpButton } from './signupbutton'
import './navbar.css'
import NavLogo from '../Images/navbar_logo.png'

const Navbar = () => {

    const [click, setClick] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const handleClick = () => {
        setClick(!click)
    }

    const closeMobileMenu = () => {
        setClick(false);
    }

    const onMouseEnter = () => {
        if (window.innerWidth < 960) {
            setDropdown(false)
        } else {
            setDropdown(true);
        }
    }

    const onMouseLeave = () => {
        if (window.innerWidth < 960) {
            setDropdown(false)
        } else {
            setDropdown(false);
        }
    }

    // Add scroll listener
    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 20) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (

        <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
            <Link to='/' className='navbar-logo'>
                <img src={NavLogo} alt='navlogo' className='logo-img' />
            </Link>

            <div className='menu-icon' onClick={handleClick}>
                <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>

            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                <li className='nav-item'>
                    <Link to='/home' className='nav-links' onClick={closeMobileMenu}>
                        Home
                    </Link>
                </li>

                <li className='nav-item'>
                    <Link to='/about' className='nav-links' onClick={closeMobileMenu}>
                        About
                    </Link>
                </li>

                <li className='nav-item'>
                    <Link to='/services' className='nav-links' onClick={closeMobileMenu}>
                        Services
                    </Link>
                </li>

                {/* <li className='nav-item'
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}>
                    <Link to='/about' className='nav-links' onClick={closeMobileMenu}>
                        About <i className='fas fa-caret-down' />
                    </Link>
                    {dropdown && <Dropdown />}
                </li> */}

                <li className='nav-item'>
                    <Link to='/contact' className='nav-links' onClick={closeMobileMenu}>
                        Contact
                    </Link>
                </li>

                {/* <li className='nav-item'>
                    <Link to='/faqs' className='nav-links' onClick={closeMobileMenu}>
                        FAQ
                    </Link>
                </li> */}

                {/* <li className='nav-item'>
                        <Link to='/signup' className='nav-links-mobile' onClick={closeMobileMenu}>
                            Sign up
                        </Link>
                    </li> */}
            </ul>

            {/* <SignUpButton /> */}
        </nav>
    )
}

export default Navbar;

